import http from './httpRequest'

// 发送好友请求
export function sendFriendRequest(data) {
  return http({
    url: '/friend/request/send',
    method: 'post',
    data
  })
}

// 处理好友请求
export function handleFriendRequest(data) {
  return http({
    url: '/friend/request/handle',
    method: 'post',
    data
  })
}

// 获取收到的好友请求列表
export function listReceivedRequests() {
  return http({
    url: '/friend/request/received',
    method: 'get'
  })
}

// 获取发送的好友请求列表
export function listSentRequests() {
  return http({
    url: '/friend/request/sent',
    method: 'get'
  })
}

// 获取未读好友请求数量
export function getUnreadCount() {
  return http({
    url: '/friend/request/unread/count',
    method: 'get'
  })
}

// 将好友请求标记为已读
export function markAsRead(requestId) {
  return http({
    url: `/friend/request/mark/read/${requestId}`,
    method: 'post'
  })
} 